export interface CreateCmsCredentialDTO {
  customerId: string;
  cmsUsername: string;
  cmsPassword: string;
  cmsGroupId: string;
}

export class CmsCredentialToCreateDTO implements CreateCmsCredentialDTO {
  customerId: string;
  cmsUsername: string;
  cmsPassword: string;
  cmsGroupId: string;

  constructor(customerId: string, cmsUsername: string, cmsPassword: string, cmsGroupId: string) {
    this.customerId = customerId;
    this.cmsUsername = cmsUsername;
    this.cmsPassword = cmsPassword;
    this.cmsGroupId = cmsGroupId;
  }
}
